'use strict';

import Modal from 'org/components/common/Modal';
import QRCode from 'easyqrcodejs';

/**
 * Converts a given string into a URL-friendly slug.
 *
 * @param {string} text - The input string to be slugified.
 * @returns {string} The slugified version of the input string.
 *
 * @example
 * // returns "hello-world-this-is-a-test"
 * slugify("Hello World! This is a test.");
 */
function slugify(text) {
    return text
        .toString() // Convert to string
        .toLowerCase() // Convert to lowercase
        .trim() // Remove whitespace from both ends
        .replace(/[\s\W-]+/g, '-') // Replace spaces and non-word characters with a single hyphen
        .replace(/^-+|-+$/g, ''); // Remove leading or trailing hyphens
}

export default class MembershipQRModal extends Modal {
    createTarget() {
        this.$target = $('#rewardsQR').clone().attr('id', this.targetID);
        $('body').append(this.$target);
        this.$el.attr('data-target-id', this.targetID);
    }

    afterOpenModal() {
        super.afterOpenModal();
        this.$target.find('.g-rewards-qr-member-type').text(this.config.memberTypeLabel).addClass(slugify(this.config.memberType));
        this.$target.find('.g-rewards-qr-member-since').text(this.config.memberSince);
        this.$target.find('.g-rewards-qr-text').text(this.config.memberNo);
        var options = {
            text: this.config.memberNo,
            width: 192,
            height: 192,
            colorDark: '#000001',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.M
        };
        if (!this.qrCode) {
            this.qrCode = new QRCode(this.$target.find('.g-rewards-qr-image').get(0), options);
        }
    }
}
